export const DefaultListCodesRequestArgs = {
  categoryCode: '',
};
